var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"company__header--list"},_vm._l((_vm.companies),function(company,index){return _c('CompanyCard',{key:index,attrs:{"company":company,"selectedCompany":_vm.currentCompany},on:{"setSelectedCompany":_vm.setSelectedCompany,"onClick":(company) => _vm.handleRedirect(company)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }